export enum CartListFilterStateEnum {

  Paid = 1,
  Active = 0

}
